export default __webpack_public_path__ + "static/plus-orange-cbb582a839bef65fa8b8ec3d1bc83557.png";